import { atom } from "recoil";
import { FirebaseAuthTypes } from "@react-native-firebase/auth";

export const phoneNumberConfirmResult = atom<FirebaseAuthTypes.ConfirmationResult | undefined>({
    key: "phoneNumberConfirmResult",
    default: undefined,
    // we need to allow mutability because the confirmation result method is broken
    // if we let de default value be immutable
    dangerouslyAllowMutability: true,
});

export const onboardingPermitTypeAtom = atom<OnboardingPermitType | undefined>({
    key: "onboardingPermitType",
    default: undefined,
});

export type OnboardingPermitType = "swiss_or_permit" | "no_permit";
